import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { AppStatusChoice } from "@/types/borrower";
import { useBorrowerDealActions } from "@/components/borrower/BorrowerDealActions";
import { WorkflowBucketGroup } from "./workflowBuckets";
import WorkflowCard from "./WorkflowCard";

interface WorkflowColumnProps {
  bucket: WorkflowBucketGroup;
  isLoading: boolean;
  statusChoices?: AppStatusChoice[];
}

const WorkflowColumn: React.FC<WorkflowColumnProps> = ({ bucket, isLoading, statusChoices }) => {
  const dealActions = useBorrowerDealActions();

  return (
    <>
      <div data-testid={`workflow-bucket-${bucket.key}`} className="h-full min-w-0">
        <Card
          className="flex h-full flex-col overflow-hidden border-t-4 shadow-sm"
          style={{ borderTopColor: bucket.color }}
        >
          <div className="flex w-full items-center justify-between border-b px-4 py-3">
            <div className="flex items-center gap-2">
              <span className="text-sm font-bold">{bucket.label}</span>
              <Badge
                variant="secondary"
                className="min-w-8 justify-center font-bold"
                style={{ backgroundColor: `${bucket.color}26`, color: bucket.color }}
              >
                {isLoading ? "..." : bucket.borrowers.length}
              </Badge>
            </div>
          </div>

          <CardContent className="min-h-0 flex-1 overflow-y-auto bg-[#fafbfc] px-3 py-3">
            {isLoading ? (
              <div className="space-y-3">
                {[1, 2, 3].map((i) => (
                  <Skeleton key={i} className="h-[88px] w-full rounded-lg" />
                ))}
              </div>
            ) : bucket.borrowers.length > 0 ? (
              bucket.borrowers.map((borrower) => (
                <WorkflowCard
                  key={borrower.id}
                  borrower={borrower}
                  color={bucket.color}
                  statusChoices={statusChoices}
                  dealActions={dealActions}
                />
              ))
            ) : (
              <div className="flex h-full min-h-[120px] items-center justify-center">
                <p className="text-sm italic text-muted-foreground">No applications</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
      {dealActions.dialogs}
    </>
  );
};

export default WorkflowColumn;
